import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-home',
  templateUrl: './empty-home.component.html',
  styleUrls: ['./empty-home.component.scss']
})
export class EmptyHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/empty-home/empty-home.component.ts